import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { companyKeys } from '../companyKeys'
import { companyComplianceKeys } from '../compliance/companyComplianceKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useAssignCompliancesToCompany = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['assignCompliancesToCompany']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...options,
    ...companyKeys.assignCompliancesToCompany,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(companyKeys.getCompanyDetails._def)
      queryClient.invalidateQueries(companyComplianceKeys._def)
      options?.onSuccess?.(...args)
    },
  })
}
